import { createStore } from 'vuex'
import httpRequest from '@/request/index';
export default createStore({
	state: {
		isLogin: false,
		userInfo: {},
		userBalance:0,
		bntoken: "",
		cartItem: JSON.parse(localStorage.getItem("cartItems")) || {},
		totalNum: 0, //总数量
		totalPrice: 0, //总价

	},
	mutations: {
		cklogin(state,data) {
			if(data.state==1){
				state.isLogin = true;
				state.userInfo = JSON.parse(data.info);
				state.userBalance = data.balance;
			}else {
				state.isLogin = false;
				//console.log("删除");
				localStorage.removeItem('bntoken');
				//跳转到登录界面
			}
			//this.commit("test");
		},
		login(state, token) {
			//console.log("登录设置");
			state.isLogin = true;
			localStorage.setItem('bntoken',token);
		},
		logout(state) {
			//console.log("退出啊");
			state.token = "";
			state.isLogin = false;
			localStorage.removeItem('bntoken');
			localStorage.removeItem('cartItems');//清空购物车
		},
		addCart(state, data){
			state.cartItem[data.id]=data;
		},
		editCart(state, data) {
			//console.log("改变数据",data)
			if(data.count>0){
				state.cartItem[data.id].count=data.count;
			}else{
				delete state.cartItem[data.id];
			}
		},
		clearCart(state){
			state.cartItem={};
			localStorage.removeItem('cartItems');
			console.log("清空购物车",state.cartItem);
		},
		countCart(state){
			state.totalPrice = 0;
			state.totalNum=0;
			//console.log("购物车统计",state.cartItem);
			for(let key in state.cartItem){
				//console.log(key);
				if(state.cartItem[key]&&state.cartItem[key].count>0){
					state.totalNum++;
					//state.totalNum += state.cartItem[key].count;
					//state.totalPrice += state.cartItem[key].item.price * state.cartItem[key].count;
				}else{
					//console.log("删除数据",state.cartItem[key]);
					delete state.cartItem[key];
				}
			}
			localStorage.setItem('cartItems', JSON.stringify(state.cartItem))
		},
	},
	actions:{
		addCart(context,data) {
			context.commit('addCart',data);
			context.commit('countCart');
		},
		editCart(context,data){
			context.commit('editCart',data);
			context.commit('countCart');
		},
		clearCart(context) {
			context.commit('clearCart');
			context.commit('countCart');
		},
		async cklogin(context){
			await httpRequest({method:"get",url:"?file=cklogin"}).then((res) => {
				context.commit('cklogin',res);
			})
		},
	},
})
